import ProductContractCard from 'components/molecules/card/product-contract/ProductContractCard';
import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarPage } from 'components/templates';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useTranslation } from 'react-i18next';
import { IChannelMutationForm } from 'services/channel/types/query';

const ChannelContracts = () => {
  const { values, status }: IFormikContextType<IChannelMutationForm> =
    useFormikContext<IChannelMutationForm>();

  const { t } = useTranslation();

  return (
    <TopbarPage
      topbar={
        <TopBar
          customBackItem={<div />}
          title={`${t('input.label.per-video-settlement')}: ${
            !values.settlementInfo?.perVideoSettlement
              ? t('input.option.no')
              : t('input.option.yes')
          }`}
        />
      }>
      <ListWrapper
        isLoading={status?.isLoading}
        items={values.settlementInfo?.contracts}
        item={(contract, index) => (
          <ProductContractCard key={index} contract={contract} />
        )}
      />
    </TopbarPage>

    // <Table
    //   id={"ChannelContracts"}
    //   size="compact"
    //   data={{
    //     nodes:
    //       values.settlementInfo?.contracts?.map((_, i) => ({
    //         ..._,
    //         id: i,
    //       })) ?? [],
    //   }}
    //   columns={[
    //     {
    //       label: `${t("input.label.global")}`,
    //       renderCell: ({ labelName: name, labelId: id, id: index }) => (
    //         <TableItem>
    //           <TableItem.Text text={name} />
    //         </TableItem>
    //       ),
    //       resize: true,
    //     },
    //     {
    //       label: t(`input.label.contract`),
    //       renderCell: (contract) => (
    //         <TableItem>
    //           <TableItem.Text text={contract.contractName} />
    //         </TableItem>
    //       ),
    //       resize: true,
    //     },
    //     {
    //       label: t(`input.label.date`),
    //       renderCell: (contract) => (
    //         <TableItem>
    //           <TableItem.Text text={`${formatDate(contract.startDate)}`} />
    //         </TableItem>
    //       ),
    //       resize: true,
    //     },

    //     {
    //       label: t(`input.label.division`),
    //       renderCell: ({ divisionPercentage, id: index }) => (
    //         <TableItem>
    //           <TableItem.Text text={`${divisionPercentage ?? "-"}%`} />
    //         </TableItem>
    //       ),
    //     },
    //     {
    //       label: "",
    //       renderCell: ({ id: index, labelId, contractId }) => (
    //         <TableItem justifyPosition="end"></TableItem>
    //       ),
    //     },
    //   ]}
    // />
  );
};

export default ChannelContracts;
